module.exports = __webpack_public_path__ + "media/loop.05d90bce.webm";